<template>
  <header>
    <div class="left" @click="onHomeClick" v-if="showHome && !showBack">
      <icon>tab_shouye</icon>
    </div>
    <div class="left" @click="onBackClick" v-if="showBack">
      <img src="../../image/global/iconLeftBack@3x.png" width="11px" height="18px" alt="">
    </div>
    <div class="left" v-if="!showHome && !showBack">
      <slot name="left"></slot>
    </div>
    <div class="title">
      <slot name="title">
        {{routerTitle}}
      </slot>
    </div>
    <div class="right">
      <slot name="right">
      </slot>
    </div>
  </header>
</template>
<script>
  import icon from '../components/icon'

  export default {
    name: 'my-header',
    props: {
      showHome: {
        type: Boolean,
        default: true
      },
      showBack: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      routerTitle() {
        const self = this
        let title = ''
        this.$router.options.routes.forEach(el => {
          (function loopChild(child) {
            if(child.name === self.$route.name) {
              return title = child.title
            }
            if(!child.children) {
              return
            }
            child.children.forEach(loopChild);
          })(el)
        })
        return title
      },
    },
    components: {
      icon,
    },
    methods: {
      onHomeClick() {
        this.$router.push('/')
        this.$emit('on-home-click')
      },
      onBackClick() {
        this.$router.go(-1)
      }
    },
  }
</script>
<style lang="less" scoped>
  @import '../../stylesheet/variable';

  @inkGrey: rgb(25,26,27);
  header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: @headerHeight;
    line-height: @headerHeight;
    overflow: hidden;
    margin: 0;
    padding: 0;
    z-index: 3000;
    background-color: #ffffff;
    display: flex;
    & > div {
      float: left;
      height: @headerHeight;
    }
    &::after {
      .setBottomLine();
    }
    i {
      display: block;
      font-size: 23px;
      color: @inkGrey;
    }
    .left {
      min-width: 15%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-left: 15px;
      // & > i {
      //   margin-left: 10px;
      // }
    }
    .title {
      text-align: center;
      font-size: 17px;
      // display: flex;
      // justify-content: center;
      // align-items: center;
      color: @inkGrey;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      div {
        color: @inkGrey;
      }
    }
    .right {
      width: 15%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 15px;
      div {
        width: 100%;
        text-align: right;
      }
    }
  }
</style>
